import React from 'react';
import './Menu.scss';

import { DropdownMenu, Header } from '@components';

import { Button, Container, mesChantiers, richessesHumaines, santeSecurite, Separator, Typography } from '@design-system';

import { MdLogout } from 'react-icons/md';

import { logout } from '@features/auth';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { chantiersItems, richessesHumainesItems, santeSecuriteItems } from '../../core/DropdownMenuItems';

export type MenuProps = {
    showMenu: boolean;
};

export const Menu: React.FC<MenuProps> = ({ showMenu }) => {
    const navigate = useNavigate();

    const dispatch = useDispatch();

    const logoutUser = () => {
        dispatch(logout());
        navigate('/login');
    };

    return (
        <div className={`menu ${showMenu ? 'menu-open' : 'menu-closed'}`}>
            <Header>
                <Typography intrinsic="h1">Menu</Typography>
            </Header>
            <Container className="menu-content">
                <div className="dropdowns-container">
                    <DropdownMenu title="Mes chantiers" icon={mesChantiers} variant="red" items={chantiersItems} />

                    <DropdownMenu title="Richesses humaines" icon={richessesHumaines} variant="yellow" items={richessesHumainesItems} />

                    <DropdownMenu title="Santé sécurité au travail" icon={santeSecurite} variant="blue" items={santeSecuriteItems} />
                </div>
                <div>
                    <Separator className="menu-separator" />
                    <Container>
                        <div className="bottom-container">
                            <Button color="green" variant="secondary" size="small" onClick={() => navigate('/signature/update')}>
                                <Typography intrinsic="h4">Signature</Typography>
                            </Button>
                            <Button color="grey" variant="tertiary" icon={<MdLogout />} iconSize={22} onClick={logoutUser}>
                                <Typography intrinsic="h4">Déconnexion</Typography>
                            </Button>
                        </div>
                    </Container>
                </div>
            </Container>
        </div>
    );
};
